import React, {Component} from 'react'; 
import {   Link } from 'react-router-dom'; 
import { base_url} from '../common/Constants';

class Footer extends Component {

    constructor(){
        super();
        this.state = {
            
        }
    }
    componentDidMount()
    { 

       
    }

      
    render()
    {
        if (this.state.loading === 1) {
            return <div>Loading...</div>;
          }
 
  return (
 
                 <footer class="site-footer footer-dark">
           
            <div class="footer-top overlay-wraper">
                <div class="overlay-main"></div>
                <div class="container">
                    <div class="row">
                       
                        <div class="col-lg-3 col-md-6">  
                            <div class="widget widget_about">
                                <h4 class="widget-title">About Company</h4>
                                <div class="logo-footer clearfix p-b15">
                                    <Link to={base_url}><img src={base_url +"assets/images/footer-logo-dark-1.png"} width="230" height="67" alt="" /></Link>
                                </div>
                                <p>{JSON.parse(localStorage.getItem("settings")).site_footer_text}
                                </p> 
								 
                            </div>
                        </div> 
                        
                        <div class="col-lg-3 col-md-6 col-sm-6">
                            <div class="widget widget_services">
                                <h4 class="widget-title">Useful links</h4>
                                <ul>
                                   <li><Link to={base_url+`about-us`}>About us</Link></li>
							 		
							    <li><Link to={base_url+`quality-policy`}>Quality and Safety</Link></li> 
							<li><Link to={base_url+`projects`}>Projects</Link></li>
							<li><Link to={base_url+`clients`}>Client Lists</Link></li>
							<li><Link to={base_url+`projects`}>Projects</Link></li>
                            <li><Link to={base_url+`careers`}>Careers</Link></li>
                            <li><Link to={base_url+`contact`}>Contact us</Link>  </li>
                                </ul>
                            </div>
                        </div>      
                        
                        <div class="col-lg-3 col-md-6 col-sm-6">
                            <div class="widget widget_services">
                                <h4 class="widget-title">Our Division</h4>
                                <ul>
                                    {JSON.parse(localStorage.getItem("divisions")).map((item, index) => (
                                                                   <li><Link to={base_url+`divisions/${item.slug}`}>{item.title}</Link></li>
                                                               ))} 
                                </ul>
                            </div>
                        </div>
                         
						<div class="col-lg-3 col-md-6 col-sm-6">
                            <div class="widget widget_services">
                                <h4 class="widget-title">Contact Details</h4>
                                <ul>
                                    <li><div class="icon-content">
                                    <h5 class="wt-tilte text-uppercase m-b0">Address</h5>
                                    {JSON.parse(localStorage.getItem("settings")).site_factory_address}
                                    </div>
                                </li>
                                        <li><h5 class="wt-tilte text-uppercase m-b0">Phone</h5>
                                    <p class="m-b0"><Link to={JSON.parse(localStorage.getItem("settings")).site_factory_number}>{JSON.parse(localStorage.getItem("settings")).site_factory_number}</Link></p>
										</li>	
											<li><h5 class="wt-tilte text-uppercase m-b0">Fax</h5>
                                    <p class="m-b0">+971-2-5556289</p>
                                     </li>
                                        <li><h5 class="wt-tilte text-uppercase m-b0">Email</h5>
                                    <p class="m-b0">{JSON.parse(localStorage.getItem("settings")).site_email_address}</p>
                                   </li>
                                        
                                </ul>
                            </div>
                        </div>
                        
                    
                </div>
            </div>
            </div>
            
            <div class="footer-bottom overlay-wraper">
                <div class="overlay-main"></div>
                <div class="constrot-strip"></div>
                <div class="container p-t30">
                    <div class="row">
                        <div class="wt-footer-bot-left">
                            <span class="copyrights-text">© 2025 CCME. All Rights Reserved. Designed By IITS.</span>
                        </div>
                        
                    </div>
                </div>
            </div>
        </footer>
 )
};
}
export default Footer;